export default {
  websiteBaseUrl: 'https://www.roomvu.com',
  apiBaseUrl: 'https://www.roomvu.com/api',
  dashboardBaseUrl: 'https://www.roomvu.com/dashboard',
  imgBaseUrl: 'https://img.roomvu.com/',
  useProxyForApiCall: false,
  auth: {
    loginUrl: 'https://www.roomvu.com/login',
    loginApiUrl: '/user/login',
    userAuthenticationUrl: '/user/get',
  },
  googleCaptcha: {
    siteKey: '6LeuuJcUAAAAAJtpfdUpKvjxk62bbz3KCNVfGkuz',
  },
  webEngage: {
    licenseCode: '82617805',
  },
  intrack: {
    IntrackAppKey: 'XXXXXXXXX',
    IntrackAuthKey: 'XXXXXXXXX',
    IntrackPublicKey: 'XXXXXXXXX',
  },
  facebook: {
    appId: '629792100977483',
  },
  intercom: {
    IntercomAppID: 'XXXXXXXXX',
  },
  clarity: {
    projectId: 'XXXXXXXXXX',
  },
  sentry: {
    DSN: 'https://0f2b2605c4334568a8e46d435cc7f6f1@sentry.roomvu.com/5',
    environment: 'development',
  },
};
